'use client';

import { sendGAEvent } from '@next/third-parties/google';
import { Link } from '@/navigation';
import ArrowLabel from '@/components/ui/ArrowLabel';

// The gold estimate CTA inside a blog article. Mirrors the hero CTA styling
// and reports which article converted the click ("does the blog bring leads?").
export default function ArticleCta({ label, articleId }: { label: string; articleId: string }) {
  return (
    <Link
      href="/#calc-form"
      onClick={() =>
        sendGAEvent('event', 'cta_click', { cta_location: 'blog_article', article_id: articleId })
      }
      className="cta-gold group inline-flex items-center justify-center rounded-full px-8 py-5 text-center font-headline text-body-md font-bold text-background transition-transform duration-200 hover:scale-[1.03] active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background"
    >
      <ArrowLabel>{label}</ArrowLabel>
    </Link>
  );
}
